import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <AppSection />
        <CommentsSection />
        <AboutSection />
        <UpdatesSection />
        <CardsSection />
        <IndexSection />
        <TopicsSection />
        <CarouselSection />
        <ContactSection />
        <FeaturesSection />
        <FaqSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}